import type {
  SwitchProps as ChakraSwitchProps,
  ThemingProps,
} from '@chakra-ui/react';
import { Switch as ChakraSwitch } from '@chakra-ui/react';
import React from 'react';

import type { OmitChakraProps } from '../../utils/typeUtils';
import { withChakraAs } from '../../utils/withChakraAs';

export interface SwitchProps
  extends OmitChakraProps<ChakraSwitchProps, keyof ThemingProps> {
  size?: never;
}

export const Switch = withChakraAs<SwitchProps, 'input'>((props) => {
  return <ChakraSwitch {...props} />;
});
